export const AMOUNT_PLACEHOLDER = "-";

export const toAmount = (value: unknown): number | null => {
	if (value === null || value === undefined || value === "") {
		return null;
	}

	const parsed = typeof value === "number" ? value : Number(value);

	return Number.isFinite(parsed) ? parsed : null;
};

export const toAmountOrZero = (value: unknown): number => toAmount(value) ?? 0;

/** Two decimals when the amount has cents, none when it is whole. */
export const centsFractionDigits = (amount: number): 0 | 2 =>
	Math.round(amount * 100) % 100 === 0 ? 0 : 2;

export const sumAmounts = (...values: unknown[]): number | null => {
	const present = values
		.map(toAmount)
		.filter((value): value is number => value !== null);

	return present.length === 0
		? null
		: present.reduce((total, value) => total + value, 0);
};

const roundTo = (value: number, decimalPlaces: number) =>
	Number(
		`${Math.round(Number(`${value}e${decimalPlaces}`))}e-${decimalPlaces}`
	);

/**
 * The library's `formatPercentage`, kept pure so server code and unit tests can
 * use it: `5.5` -> `"5,50%"`, and no decimals once rounded to a whole number.
 */
export const formatPercent = (value: number, decimalPlaces = 2): string => {
	const rounded = roundTo(value, decimalPlaces);
	const digits = rounded % 1 === 0 ? 0 : decimalPlaces;

	return `${roundTo(value, digits).toFixed(digits).replace(".", ",")}%`;
};

export const formatRate = (value: unknown, decimalPlaces?: number): string => {
	const rate = toAmount(value);

	if (rate === null) {
		return AMOUNT_PLACEHOLDER;
	}

	return formatPercent(rate, decimalPlaces);
};
